import { Card, CardContent, Grid, CardHeader, Button } from "@mui/material";
import { useEffect, useState } from "react";
import { apiConstants } from '../../common/constants'
import * as React from 'react'
import PageTitle from "../../components/PageTitle";
import { useSnackbar } from "notistack";
import Loader from "../../common/Loader";
import { useForm } from "react-hook-form";
import { FormProvider } from "../../common/hook-form";
import { LoadingButton } from "@mui/lab";
import { MerchantFilterCached } from "../../common/ProshipFormComponents";
import { getGeneric, postGeneric } from "../../common/constants";
import RHFMultipleSelectField from "../../common/hook-form/RHFMultipleSelectField";


const CodOnHoldConfig = () => {
    const { enqueueSnackbar } = useSnackbar();
    const [storeNames, setStoreNames] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [reload, setReload] = useState(0);

    const methods = useForm({
        // resolver: yupResolver(PostSchema),
        defaultValues: {
            selectedStores: [],
            merchant: null
        },
    });

    const { handleSubmit, setValue, watch, reset } = methods;
    const merchantId = watch('merchant');

    useEffect(() => {
        const fetchMerchantData = async () => {
            if (!merchantId) return;
            setIsLoading(true);
            try {
                const [storeNamesRes, merchantDetailsRes] = await Promise.all([
                    getGeneric(`${apiConstants.GET_UNIQUE_STORE_NAMES}?merchantOid=${merchantId}`),
                    getGeneric(`${apiConstants.MERCHANT_DETAILS}/${merchantId}`)
                ]);

                const storeNamesData = storeNamesRes?.data || [];
                const merchantDetailsData = merchantDetailsRes?.data?.codOnHoldConfig || {};
                setStoreNames(storeNamesData);
                // Set default form values once both are available
                const selectedStores = storeNamesData.filter(store =>
                    merchantDetailsData?.storeNames?.includes(store)
                );

                setValue('selectedStores', selectedStores);

            } catch (error) {
                console.error(error);
                enqueueSnackbar(error?.message || 'Something went wrong', { variant: 'error' });
            } finally {
                setIsLoading(false);
            }
        };

        fetchMerchantData();
    }, [merchantId, reload]);

    const onSubmit = async (data) => {
        setIsSubmitting(true);
        try {
            const response = await postGeneric(`${apiConstants.MERCHANT_DETAILS}/${merchantId}/codOnHold`, {
                isActive: true,
                storeNames: data.selectedStores
            })
            setReload(prev => prev + 1);
            if (response?.status === 200) {
                enqueueSnackbar('COD On Hold Configuration updated successfully', { variant: 'success' });
            } else {
                enqueueSnackbar('Something went wrong', { variant: 'error' });
            }
        } catch (error) {
            enqueueSnackbar(error?.message || 'Something went wrong', { variant: 'error' });
        } finally {
            setIsSubmitting(false);
        }
    }

    // Create options for the select field
    const storeOptions = storeNames.map(storeName => ({
        label: storeName,
        value: storeName
    }));



    return (
        <>
            {isLoading && <Loader />}
            <PageTitle>COD On Hold Configuration</PageTitle>
            <Card>
                <CardHeader title='COD On Hold Configuration' subheader='Select store names that should have COD orders placed on hold' />
                <CardContent>
                    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
                        <Grid container spacing={2}>
                            <Grid item xs={4}>
                                <MerchantFilterCached label="Select Merchant" required />
                            </Grid>
                            {merchantId && (
                                <Grid item xs={6} sx={{ mt: 1 }}>
                                    <RHFMultipleSelectField
                                        width="100%"
                                        name="selectedStores"
                                        label="Select Store Names"
                                        options={storeOptions}
                                        size="medium"
                                        // required
                                    />
                                </Grid>
                            )}
                            <Grid item xs={2} sx={{ display: 'flex', alignItems: 'center' }}>
                                <LoadingButton
                                    loading={isSubmitting}
                                    variant="contained"
                                    size="small"
                                    type="submit"
                                >
                                    Submit
                                </LoadingButton>
                                <Button sx={{ ml: 1 }} variant="contained" size="small" color="error" onClick={() => {
                                    reset();
                                }}>
                                    Reset
                                </Button>
                            </Grid>
                        </Grid>
                    </FormProvider>
                </CardContent>
            </Card>
        </>
    )
}

export default CodOnHoldConfig;